import React, {useState} from "react";
import { ChevronDown } from "../../assets/svgs/icons-svg";
import { FileDropzone } from "./FileDropzone";
import { KYCForm } from "../../interfaces/bank";

const ID_TYPES = ["NIN", "BVN", "Passport", "Driver's License", "Voter's Card"];

export function KYCFormView({ onSave, initialValues }: {
  onSave: (form: KYCForm) => void
  initialValues?: Partial<KYCForm>
}) {
  const [form, setForm] = useState<KYCForm>(() => ({
    fullName: initialValues?.fullName ?? "",
    dateOfBirth: initialValues?.dateOfBirth ?? "",
    idType: initialValues?.idType ?? "",
    idNumber: initialValues?.idNumber ?? "",
    idExpiryDate: initialValues?.idExpiryDate ?? "",
    idDocument: null,
  }));

  const isValid = !!(form.fullName && form.dateOfBirth && form.idType && form.idNumber);

  return (
    <div className="space-y-5">
      <h3 className="text-base font-semibold text-gray-900">KYC Verification <span className="font-normal text-gray-500">[1,000,000 Max]</span></h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {/* Full Name */}
        <div className="space-y-1.5">
          <label className="text-sm font-medium text-gray-700">Full Name <span className="text-red-500">*</span></label>
          <input type="text" placeholder="Adeyemi Akpan" value={form.fullName} onChange={(e) => setForm({ ...form, fullName: e.target.value })} className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-gray-900" />
        </div>

        {/* Date of Birth */}
        <div className="space-y-1.5">
          <label className="text-sm font-medium text-gray-700">Date of Birth <span className="text-red-500">*</span></label>
          <input type="date" value={form.dateOfBirth} onChange={(e) => setForm({ ...form, dateOfBirth: e.target.value })} className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-gray-900" />
        </div>

        {/* ID Type */}
        <div className="space-y-1.5">
          <label className="text-sm font-medium text-gray-700">ID Type <span className="text-red-500">*</span></label>
          <div className="relative">
            <select value={form.idType} onChange={(e) => setForm({ ...form, idType: e.target.value })} className="w-full appearance-none border border-gray-300 rounded-lg px-3 py-2.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-gray-900 pr-8">
              <option value="">NIN</option>
              {ID_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
            <ChevronDown />
          </div>
        </div>

        {/* ID Number */}
        <div className="space-y-1.5">
          <label className="text-sm font-medium text-gray-700">ID Number <span className="text-red-500">*</span></label>
          <input type="text" placeholder="7865479533" value={form.idNumber} onChange={(e) => setForm({ ...form, idNumber: e.target.value })} className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-gray-900" />
        </div>

        {/* ID Expiry Date */}
        <div className="space-y-1.5 md:col-span-1">
          <label className="text-sm font-medium text-gray-700">ID Expiry Date <span className="text-gray-400">(if any)</span></label>
          <input type="date" value={form.idExpiryDate} onChange={(e) => setForm({ ...form, idExpiryDate: e.target.value })} className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-gray-900" />
        </div>
      </div>

      {/* Upload ID Document */}
      <div className="space-y-1.5">
        <label className="text-sm font-medium text-gray-700">Upload ID Document <span className="text-gray-400">[Unlimited]</span></label>
        <FileDropzone file={form.idDocument} onChange={(f) => setForm({ ...form, idDocument: f })} />
      </div>

      <div className="flex justify-end pt-2">
        <button disabled={!isValid} onClick={() => isValid && onSave(form)} className={`px-6 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${isValid ? 'bg-gray-900 text-white enabled:hover:bg-gray-700 enabled:active:scale-95' : 'bg-gray-200 text-gray-600 disabled:cursor-not-allowed disabled:opacity-100 disabled:transform-none disabled:shadow-none'}`}>Save</button>
      </div>
    </div>
  );
}
